App.namespace.wrap('views.shared.fixTooltips', (options) => {

  const POSITION_ATTRIBUTE = 'data-microtip-position';
  const ORG_POSITION_ATTRIBUTE = 'data-microtip-org-position'


  const fixPositions = () => {
    console.time('tooltips-position');
    // data-microtip-position="right" indicates that tooltip will be on left from the handler for some strange reason
    let container = options?.container;
    if (!container) {
      container = document;
    }
    const tooltips = container.querySelectorAll('[aria-label][role="tooltip"]');

    Array.from(tooltips).forEach(element => {
      let positionValue = element.getAttribute(POSITION_ATTRIBUTE);
      let orgPositionValue = element.getAttribute(ORG_POSITION_ATTRIBUTE);

      if (options?.repaint) {
        // revert back to original position
        if (orgPositionValue && orgPositionValue.length > 0) {
          element.setAttribute(POSITION_ATTRIBUTE, orgPositionValue);
        } else {
          element.removeAttribute(POSITION_ATTRIBUTE);
        }
      } else {
        element.setAttribute(ORG_POSITION_ATTRIBUTE, positionValue ?? '');
      }

      const tooltipWidth = 150 + 16;
      const { right, left, width } = element.getBoundingClientRect();

      if (right + width / 2 < tooltipWidth / 2) {
        element.setAttribute(POSITION_ATTRIBUTE, 'right');
      }
      if (left + width / 2 < tooltipWidth / 2) {
        element.setAttribute(POSITION_ATTRIBUTE, 'left');
      }
    });
    console?.timeEnd('tooltips-position');
  }

  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(fixPositions, 1000);
  });

  if (options?.force) {
    fixPositions();
  } else if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fixPositions, 1000);
  }
});
